<template>
  <div>

    <div style="position: absolute;top: 0;right: 0;left: 0;bottom: 0;overflow: hidden;">
      <img style="object-fit: cover;width: calc(100% - 600px);height: 100%;" src="../../assets/img/login.png"/>
    </div>



    <div class="rightContent">
      <div class="rightContent-body" v-if="!multipleCheck" >
        <div class="localAccount">
          <img
                  class="login-logo"
                  src="../../assets/img/icontitle_1.png"
          />
          <div class="login-title">{{ $t("login.loginTitle1") }}</div>
          <div class="login-subtitle">{{ $t("login.loginTitle2") }}</div>

          <a-form :form="form">
            <a-col class="login-form-label">{{ $t("login.Username") }}</a-col>
            <a-form-item>
              <a-input
                      @pressEnter="handleSubmit"
                      @change="(e) => formValues.username = e.target.value"
                      class="login-input"
                      v-decorator="[
                  'username'
                ]"
              >
              </a-input>
            </a-form-item>

            <a-col class="login-form-label">{{ $t("login.Password") }}</a-col>
            <a-form-item>
              <a-input
                      id="password"
                      class="login-input"
                      v-decorator="[
                  'password',
                ]"
                      type="password"
                      @pressEnter="handleSubmit"
                      @change="(e) => formValues.password = e.target.value"
              >
              </a-input>
            </a-form-item>
          </a-form>

          <a-row>
            <a-col span="16">
              <div class="login-error-row" v-if="isError">
                <img class="login-info" src="../../assets/img/wrong_info.png"/>
                <div class="login-action-error-message">
                  {{ loginFailureMsg }}
                </div>
              </div>
            </a-col>
            <a-col span="8">
              <div class="forgot-row">
                <span class="forgot-link" @click="goForgot" :class="{ forgotDisabled: isSsoDisabled }">{{$t("login.ForgotPassword")}}?</span>
              </div>
            </a-col>
          </a-row>

          <a-button
                  id="loginBtnSign"
                  size="large"
                  class="login-btn-primary"
                  :loading="loginLoading"
                  :disabled="isLoginDisabled"
                  @click="handleSubmit"
                  type="primary"
          >{{ $t("login.SignIn") }}</a-button
          >

          <div class="divider-or">
            <span class="divider-line"></span>
            <span class="divider-text">{{ $t("login.Or") }}</span>
            <span class="divider-line"></span>
          </div>

          <a-button size="large" class="login-btn-sso" :disabled="isSsoDisabled" @click="handleSsoLogin">
            <svg class="microsoft-icon" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
              <rect x="1" y="1" width="9" height="9" fill="#f25022" />
              <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
              <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
            </svg>
            {{ $t("singleSignOn") }}
          </a-button>

          <div class="divider-line-full"></div>

        </div>

        <div class="login-footer">
          <!--          <a-button-->
          <!--                  size="large"-->
          <!--                  class="login-btn-register"-->
          <!--                  @click="goRegister"-->
          <!--          >{{ $t("login.RegisterNewAccount") }}</a-button-->
          <!--          >-->

          <p class="help-text">{{ $t("login.NeedHelpContactAdmin") }}</p>
        </div>
      </div>



      <div class="rightContent-body" v-if="multipleCheck">
        <div class="checkLocalAccount">
          <img class="login-logo" src="../../assets/img/icontitle_1.png" />
          <h1 style="fond-size: 10px">{{ $t("login.loginTitle3") }}</h1>
          <h2 style="fond-size: 5px">{{ $t("login.loginTitle4") }}</h2>
          <div style='width:100%;height: 35px ;margin-bottom: 50px;margin-top: -20px'>
            <span style="left: 5px;top: 40px" class="me_icon"></span>

            <select  style='width:100%;height: 50px ;border-radius: 8px;padding-left: 35px;'>
              <option class="max-width: 80px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap; " v-for="item in userEmailList"   v-bind:key="item"  value="item">{{item}}</option>
            </select>
          </div>

          <div>
<!--            <a href="javascript:;" :disabled="sendMsgShow == 'active' ? true : false"  :class="sendMsgShow" @click="sendMessage" style="color: #282828 ;display: inline-block;width: 100%;margin-bottom: 10px; ;">-->
<!--              <span class="message_icon"></span>-->
<!--              <span-->
<!--                  style="float: left; position: relative;left: 2px;top: 8px; font-size: 14px;">{{ $t("login.loginTitle5") }}{{mobileNum.length > 2 ? mobileNum.substring(mobileNum.length-2,mobileNum.length) : '**' }}-->
<!--                <br /> <span style="float: left; position: relative">{{ $t("login.loginTitle6") }}<span style="color: #E5962F">{{ $t("login.loginTitle7") }}</span>{{ $t("login.loginTitle8") }}</span> </span><br />-->
<!--            </a>-->

<!--            <a href="javascript:;"  :disabled="sendEmailShow == 'active' ? true : false"  :class="sendEmailShow" @click="sendEmail"  style="color: #282828 ;display: inline-block;width: 100%;">-->
<!--              <span class="computer_icon"> </span>-->
<!--              <span-->
<!--                  style="float: left; position: relative;left: 10px;top: 15px;font-size: 14px">{{ $t("login.loginTitle9") }}<span v-if="time > 0">({{time}}s)</span></span>-->
<!--            </a>-->

            <div style="float: left; position: relative;">
              <span class="authenticator_icon"> </span>
              <span style="float: left; position: relative;left: 10px;top:5px;font-size: 14px;text-align: left">{{ $t("login.loginTitle14") }}<br/>{{ $t("login.loginTitle15") }}</span>
              <div style="float: left; position: relative;left: 10px;top:5px;">
                <a href="javascript:;" @click="checkAuthenticator"  style="color: #282828 ;display: inline-block;width: 100%;">
                  <span v-if="useredQr!='Y' && !authenticatorCheck" style="font-weight: bold;font-size: 16px;color: black">( <span style="color: #E5962F;font-weight: bold;font-size: 16px">{{ $t("login.loginTitle16") }}</span> )</span>
                </a>
              </div>
            </div>
            <div v-if="authenticatorCheck">
              <div style="margin-left: 30px;float: left; position: relative;width: 98%;font-size: 12px;color: #969896">
                <div style="clear: both;width:100%;margin-top: 10px;text-align: left">
                  <span class="authenticator_1_icon"> </span>
                  <span style="float: left; position: relative;left: 10px;top:5px">{{ $t("login.loginTitle18") }}</span>
                  <br/>
                  <span style="float: left; position: relative;left: 10px">{{ $t("login.loginTitle19") }}</span>
                </div>
                <div style="width:100%;float: left">
                  <div style="width:55%;margin-top: 10px;float: left">
                    <span class="authenticator_2_icon"> </span>
                    <span style="float: left; position: relative;left: 10px;top:5px">{{ $t("login.loginTitle20") }}</span>
                    <br/>
                    <span style="float: left; position: relative;left: 10px">{{ $t("login.loginTitle21") }}</span>
                    <br/>
                    <span style="float: left; position: relative;left: 10px">{{ $t("login.loginTitle22") }}</span>
                    <br/>
                    <span style="float: left; position: relative;left: 35px">{{ $t("login.loginTitle23") }}</span>
                  </div>
                  <div >
                    <img :src="qrCode" alt="QR Code" style="width:110px;height: 110px;margin-right:15px">
                  </div>
                </div>
                <div style="width: 100%;float: left; position: relative;">
                  <span style="float: left; position: relative;">{{ $t("login.loginTitle25") }}</span>
                </div>
                <div style="width: 98%;height: 16px;float: left; position: relative;background-color: #7c7c7c;">
                  <span style="font-size: 12px;color: white;font-weight: bold">{{secretQr}}</span>
                </div>
                <div style="float: left; position: relative;width:100%;top:10px">
                  <span class="authenticator_3_icon"> </span>
                  <span style="float: left; position: relative;left: 10px;top:5px">{{ $t("login.loginTitle24") }}</span>
                </div>
                <div style="float: left; position: relative;width:100%;">
                  <a-input @pressEnter="verifyQR" style="border: #808080 solid 1px;  border-radius: 3px;height: 26px;width: 55%;" type="text" name="yanzhengma" v-model="qrPassword" onfocus="this.placeholder=''"></a-input>
                  <a-button id="checkBtnSign" size="large" style="width: 25%;background-color: #409eff;left: 10px;height:32px"
                            :loading="loginLoading" @click="verifyQR" type="primary">{{ $t("login.Verify") }}</a-button>
                </div>
                <div style="float: left; position: relative;width:100%;text-align: center">
                  <p  style="float: left; position: relative;left: 40px;top: 5px;bottom:5px;color: red;font-size: 14px;font-weight: bold" v-if="verifyQRError" >
                    <span :style="{color:msgColor}">{{verifyQRErrorMsg}}</span>
                  </p>
                </div>
                <div style="float: left; position: relative;left: 10px;top:10px;">
                  <a href="javascript:;" @click="checkAuthenticator"  style="color: #282828 ;display: inline-block;width: 100%;">
                    <span style="font-weight: bold;font-size: 16px;color: black">( <span style="color: #E5962F;font-weight: bold;font-size: 16px">{{ $t("login.loginTitle17") }}</span> )</span>
                  </a>
                </div>
              </div>

            </div>
            <div style="float: left; position: relative;width:100%;text-align: center">
              <p  style="float: left; position: relative;left: 10px;top: 5px;bottom:5px;color: red;font-size: 14px;font-weight: bold" v-if="verifyQRError" >
                <span :style="{color:msgColor}">{{verifyQRErrorMsg2}}</span>
              </p>
            </div>
            <div style="width:100%;margin-top: 10px">
              <div style="float: left; position: relative;width:100%;margin-top: 10px">
                <h5 style="float:left;position: relative;top: 15px;margin-bottom: 0px;left: 10px;font-weight: bold">{{ $t("login.loginTitle10") }}</h5>
              </div>
              <div style="float: left; position: relative;width:100%;">
                <input
                    style="float: left; position: relative;margin-top: 30px;border: #808080 solid 1px;border-radius: 8px;height: 50px;width: 100%;"
                    type="text" name="yanzhengma" :style="{backgroundColor: disableColor}" :disabled="disabledCheck" v-model="verificationCode" :placeholder="title11" @focus="verifyFocus" @blur="verifyBlur">
              </div>
              <p  style="float: left; position: relative;left: 40px;top: 15px;color: red;font-size: 14px;" v-if="verificationCodeError" >{{verificationCodeErrorMsg}}</p>
            </div>
            <div style="float: left; position: relative;width:100%;margin-top: 10px">
              <a-row type="flex" justify="space-between" style="float: left; position: relative;margin-top: 20px">
                <a-col>
                  <a-checkbox :style="{backgroundColor: disableColor}" :disabled="disabledCheck" :checked="trustBrowser" @change="trustBrowserChange"
                  ></a-checkbox>
                  <span style="padding-left:10px">{{ $t("login.loginTitle12") }}</span>
                </a-col>
              </a-row>
              <span style="width:90%;float: left; position: relative;left:20px;top: 10px;font-size: 13px;color: #969896;text-align: left">{{ $t("login.loginTitle13") }}<span>{{trustBrowserTime}}</span><span>{{$t("login.loginTitle27")}}</span></span>
            </div>
            <div style="float: left; position: relative;margin: 30px 0 ;width: 100%;">
              <a-row type="flex" justify="space-between"
                     style="float: left; position: relative;width: 100%;">
                <a-col style="width: 100%">
                  <a-button id="loginBtnSign" size="large" class="login-btn-primary"
                            :style="{backgroundColor: btnDisableColor}" :disabled="disabledCheck" :loading="loginLoading" @click="handleSubmit2" type="primary">{{ $t("login.SignIn") }}</a-button>
                </a-col>
              </a-row>
            </div>
          </div>
        </div>
      </div>



    </div>
  </div>
</template>
<script>
  import ajax from "../../api/ajax";
  import api from "../../api/url";
  import cookie from "../../api/cookie";
  import moment from "moment";
  import encrypt from "@assets/js/encrypt-DES";
  export default {
    data() {
      return {
        clientHeight: 0, // 声明data
        form: this.$form.createForm(this), // 表单注册
        keepMeSigned: false, // 是否保持登录
        isError: false, // 提示信息
        multipleCheck: false,
        verificationCode: null,
        verificationCodeError: false,
        verificationCodeErrorMsg: '',
        lang: false, // 语言
        loginLoading: false,
        mobileNum: '',
        sendMsgShow: '' ,
        sendEmailShow: '' ,
        time:0,
        authorizationCode: '',
        languages: [{
            code: "Eglish",
            codeDesc: "Eglish"
          },
          {
            code: "中文",
            codeDesc: "中文"
          },
        ],
        userEmailList:[] ,
        loginFailureMsg:"",
        trustBrowser:false,//是否信任浏览器   信任浏览器14天内不需要再输入验证码
        qrPassword:'',
        timeZone:'',
        trustBrowserTime:'',
        authenticatorCheck:false,
        disabledCheck:false,
        verifyQRError: false,
        verifyQRErrorMsg: '',
        verifyQRErrorMsg2: '',
        title11:'',
        msgColor:'',
        useredQr: 'N',
        secretQr: '',
        userName:'',
        // showSecret:false,
        qrCode:'',
        disableColor:'',
        btnDisableColor:'#52b7e3',
        formValues: {
          username: '',
          password: ''
        },
      };
    },
    computed: {
      isLoginDisabled() {
        return !this.formValues.username || !this.formValues.password;
      },
      isSsoDisabled() {
        return !this.formValues.username;
      }
    },
    created() {
      //如果没有这句代码，select中初始化会是空白的，默认选中就无法实现
      this.couponSelected = this.languages[0].code;
    },
    mounted() { //监控页面高度
      var _this = this;
      // 挂载读取页面高度
      _this.setClientHight();
      // 窗口页面高度变更
      window.onresize = function () {
        _this.setClientHight();
      }

      let url = new URL(window.location.href);
      let hash = window.location.hash || "";
      let hashParams = new URLSearchParams(hash.split("?")[1] || "");
      let error = url.searchParams.get("error") || hashParams.get("error");
      if (error === "sso_account_mismatch") {
        this.isError = true;
        this.loginFailureMsg = this.$t("login.SsoAccountMismatch");
        let hashPath = hash.split("?")[0] || "#/login";
        window.history.replaceState({}, document.title, window.location.pathname + hashPath);
        return;
      }

      let token = url.searchParams.get("token");
      let userName = url.searchParams.get("userName");
      if (!token || !userName) {
        sessionStorage.removeItem("authInitiateAfterRedirect");
        return;
      }
      let needLogin = sessionStorage.getItem("authInitiateAfterRedirect");
      if (needLogin === "true") {
        this.$nextTick(() => {
          sessionStorage.removeItem("authInitiateAfterRedirect");
          if (typeof token === 'string' && token.startsWith("Bearer ")) {
            token = token.replace("Bearer ", "");
          }
          sessionStorage.setItem("logout", "/login");
          sessionStorage.setItem("token", token);
          sessionStorage.setItem("domain", "true");
          this.$sessionManagerService.setCurrentUsername(userName);
          this.isError = false;
          this.$router.push({
            path: "/page"
          });
          ajax.get(api.CODEMAST).then((res) => {
            sessionStorage.setItem("localData", JSON.stringify(res.data));
          });
          ajax.get(api.SYSTEMPARAM).then(res => { //查询当前Project所有系统参数
            sessionStorage.setItem("systemParam", JSON.stringify(res.data));
          });
        });
      }
    },
watch: {
  verificationCode: {
   handler(newVal) {
       this.verificationCodeError = false
   },
   deep: true,　　immediate: false,
  }
}
    ,
    methods:
     {
         sendEmail(){
           // 校验邮箱
           var emailReg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
          if(!emailReg.test(this.userEmailList[0])){
               this.verificationCodeError = true;
              this.verificationCodeErrorMsg = this.$t("login.emailError");
               return;
          }

          // 设定样式
        this.sendEmailShow = 'active';
          // 发请求发邮件    
        ajax.get(api.USERSENDEMAIL,{email: this.userEmailList[0]}).then(res=>{
          if(res.code == 200){
              // this.$message.success('The email is sent successfully and resend 60 seconds later.');
          }else{
             this.$customMessage.error(res.msg);
          }
        })
        // 定时恢复样式
        this.time = 59;
        this.timer = setInterval(()=>{
          this.time -- ;
          if(this.time == 0){
            this.sendEmailShow = '';
             clearInterval(this.timer);
          }        
        }, 1000);
      },
       checkAuthenticator(){
         if(this.authenticatorCheck){
           this.authenticatorCheck = false;
           this.disabledCheck = false;
           this.disableColor = "#FFFFFF";
           this.btnDisableColor = "rgb(11, 151, 196)";
         }else{
           this.authenticatorCheck = true;
           this.disabledCheck = true;
           this.disableColor = "#E8E8E8";
           this.btnDisableColor = "#B5B5B5";
           this.qrCode = "data:image/png;base64,"+this.secretQc;
         }
         // ajax.get(api.GETAUTHENTICATORQR,{userName: this.userName}).then((res) => {
         //   if (res.code == 200) {
         //     this.secret = res.data.secret;
         //     this.qrCode = "data:image/png;base64,"+res.data.secretQr;
         //     this.showSecret = true;
         //   }else{
         //     this.showSecret = false
         //   }
         // });
       },
       verifyFocus(){
         this.title11 = "";
       },
       verifyBlur(){
         this.title11 = "";
         this.$nextTick(()=>{
           this.title11 =  this.$t("login.loginTitle11")
         })
       },
       verifyQR(){
         this.verifyQRError = false;
         this.msgColor="";
         this.verifyQRErrorMsg = "";
         this.verifyQRErrorMsg2 = "";
         if(this.secretQr==null||this.secretQr==''){
           this.verifyQRError = true;
           this.verifyQRErrorMsg = this.$t("login.loginTitle26");
           return;
         }
         if(this.qrPassword==null||this.qrPassword==''){
           this.verifyQRError = true;
           this.verifyQRErrorMsg = this.$t("login.Pleaseverification");
           return;
         }
         let params = {
           secret:this.secretQr,
           qrCode:this.qrPassword,
           timeZone:this.timeZone,
           userName:this.userName
         }
         ajax.post(api.VERIFYQR,params).then((res) => {
           if (res.code == 200) {
             this.authenticatorCheck = false;
             this.useredQr = "Y";

             this.verifyQRError = true;
             this.msgColor="green";
             this.verifyQRErrorMsg2 = this.$t("login.CaptchaVerified");
             this.disabledCheck = false;
             this.disableColor = "#FFFFFF";
             this.btnDisableColor = "rgb(11, 151, 196)";
           }else{
             this.verifyQRError = true;
             this.verifyQRErrorMsg = this.$t("login.CaptchaError");
           }
         });
       },
       //信任浏览器
       trustBrowserChange(e) {
         this.trustBrowser = e.target.checked;
       },
       encryptByDES(message,key) {
         var keyHex = CryptoJS.enc.Utf8.parse(key);
         //  console.log("keyHex:"+keyHex)
         var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
           mode: CryptoJS.mode.ECB,
           padding: CryptoJS.pad.Pkcs7
         });
         return encrypted.toString();
       },
      sendMessage(){
        // this.sendMsgShow = 'active';
        this.$customMessage.error('This function is not enabled.');
      // 定时恢复样式
        // this.timer = setTimeout(()=>{
        //   this.sendMsgShow = '';
        //    clearInterval(this.timer);
        // }, 10000);

      },
      setClientHight() { // 当页面高度发生变化触发事件 
        var _this = this;
        _this.clientHeight = `${document.documentElement.clientHeight}`; //设置页面高度
        var doc = document.getElementById('login_footer');
        if (doc != undefined && doc != 'null') {
          if (_this.clientHeight > 490) {
            doc.style.position = 'fixed';
          } else {
            doc.style.position = 'static';
          }
        }
      },
       goForgot() {
         let val = this.form.getFieldsValue(["username"]);
         ajax.get(api.AUTHCHECKUSERDOMAIN,{username: val.username}).then(res=>{
           if(res.code == 200){
             this.$router.push({
               path: "/forgot",
               query: {
                 name: val.username
               }
             });
           }else{
             this.isError = true;
             this.loginFailureMsg = res.msg
             return;
           }
         })

       },
      //        保持登录
      keepMeChange(e) {
        this.keepMeSigned = e.target.checked;
      },
      //        语言切换
      checkoutLang() {
        this.lang = !this.lang;
        if (this.lang) {
          this.$i18n.locale = "zh";
        } else {
          this.$i18n.locale = "en";
        }
      },
       //        SSO 登录
       handleSsoLogin() {
         this.authInitiate();
       },
       //        跳转注册页
       goRegister() {
         this.$router.push({ path: "/sign" });
       },
      handleSubmit() {
        this.form.validateFields((err, values) => {
          if (!err) {
          this.loginLoading = true;
           let utcTime = moment.utc().valueOf();
            values['password'] = encrypt.encryptByDES(values['password'],Math.floor(utcTime/ 30000).toString())
            values['timestamp'] = utcTime;
            ajax.post(api.AUTHORIZATIONCODE + "?from=PC", values).then((res) => {
              this.loginLoading = false;
              if (res.code == 200) {
                this.userName = values.username;
                this.trustBrowser = cookie.get("trustBrowser")==undefined?false:true;
                if(!this.trustBrowser){
                  this.multipleCheck = res.data.multipleCheck
                }
              if(! this.multipleCheck){ // 是否需要二次验证
                  ajax.post(api.LOGINAPI + "?from=PC", values).then((res) => {
                      this.loginLoading = false;
                      if (res.code == 200) {
                        this.infoErrorMsg = "";
                        let token = res.data;
                        if (typeof token === 'string' && token.startsWith("Bearer ")) {
                          token = token.replace("Bearer ", "");
                        }
                        sessionStorage.setItem("logout", "/login");
                        sessionStorage.setItem("token", token);
                        this.$sessionManagerService.setCurrentUsername(values.username);
                        this.isError = false;
                        this.$router.push({
                          path: "/page"
                        });
                        ajax.get(api.CODEMAST).then((res) => {
                          sessionStorage.setItem("localData", JSON.stringify(res.data));
                        });

                        ajax.get(api.SYSTEMPARAM).then(res => { //查询当前Project所有系统参数
                          sessionStorage.setItem("systemParam", JSON.stringify(res.data));
                        });

                      } else {
                        this.form.setFieldsValue({ password: '' });
                        this.formValues.password = '';
                        document.getElementById('password').focus();
                        this.isError = true;
                        this.loginFailureMsg = res.msg
                      }
                  });
               }else{
                 this.authorizationCode = res.data.AuthorizationCode
                 this.userEmailList.push(res.data.email)
                 this.mobileNum = res.data.mobileNum
                this.useredQr = res.data.useredQr
                this.secretQr = res.data.secretQr
                this.secretQc = res.data.secretQc
                this.timeZone = res.data.timeZone
                this.trustBrowserTime = res.data.trustBrowserTime
                let langUser = res.data.lang
                if(langUser!=null){
                  if(langUser == "English"){
                    this.$i18n.locale = "en";
                  }
                  if(langUser == "简体中文"){
                    this.$i18n.locale = "zh";
                  }
                  if(langUser == "繁体中文"){
                    this.$i18n.locale = "zh_tw";
                  }
                  if(langUser == "한글"){
                    this.$i18n.locale = "kor";
                  }
                }
                this.title11 = this.$t("login.loginTitle11");
               }            
              } else {
                this.isError = true;
                this.loginFailureMsg = res.msg
              }
            });
          }
        });
      },
       authInitiate(){
         this.form.validateFields(["username"], (err, values) => {
           if (!err) {
             const frontUrl = window.location.protocol + "//" + window.location.host;
             values.frontUrl = frontUrl;
             ajax.post(api.AUTHINITIATE, values).then((res) => {
               this.loginLoading = false;
               if (res.code == 200) {
                 let redirectUrl = res.data.redirectUrl || res.data;
                 if (redirectUrl) {
                   window.history.replaceState({}, document.title, window.location.pathname);
                   sessionStorage.clear();
                   sessionStorage.setItem("authInitiateAfterRedirect", "true");
                   window.location.href = redirectUrl;
                 } else {
                   this.isError = true;
                   this.loginFailureMsg = res.msg
                   return;
                 }
               } else {
                 this.isError = true;
                 this.loginFailureMsg = res.msg
               }
             });
           }
         });
       },
      handleSubmit2() {
        let params = {
          code : this.authorizationCode,
          verificationCode: this.verificationCode
        }
        ajax.post(api.LOGINAPI + "?from=PC", params).then((res) => {
              this.loginLoading = false;
              if (res.code == 200) {
                this.infoErrorMsg = "";
                let token = res.data;
                if (typeof token === 'string' && token.startsWith("Bearer ")) {
                  token = token.replace("Bearer ", "");
                }
                sessionStorage.setItem("logout", "/login");
                sessionStorage.setItem("token", token);
                if(this.trustBrowser){
                  cookie.set("trustBrowser", this.trustBrowser, 14);
                }
                this.$sessionManagerService.setCurrentUsername(this.userName);
                this.isError = false;
                this.$router.push({
                  path: "/page"
                });
                ajax.get(api.CODEMAST).then((res) => {
                  sessionStorage.setItem("localData", JSON.stringify(res.data));
                });
                // ajax.get(api.SYSTEMPARAM).then(res => { //查询当前Project所有系统参数
                //   sessionStorage.setItem("systemParam", JSON.stringify(res.data));
                // });
              } else {
                this.verificationCodeError = true;
                this.verificationCodeErrorMsg = this.$t("login.CaptchaError");
              }
        });
      }
    },
  };
</script>
<style lang="less">

.active {
  background-color: #E8F0FE;
  color: #787A81 !important;
}

  .checkLocalAccount {

    .has-error .ant-form-explain,
    .has-error .ant-form-split {
      text-align: left;
    }
    a:hover{
      background: #E8F0FE;
    }
    h2 {
      font-size: 13px;
      margin: 10px 0;
      // font-weight: bold;
    }

    h1 {
      font-size: 25px;
      margin: 10px 0;
      // font-weight: bold;
    }

    .me_icon {
      border-radius: 100%;
      float: left;
      position: relative;
      left: 50px;
      top: 3px;
      background: url("../../assets/img/login_me.png") no-repeat;
      background-size: 100% 100%;
      width: 30px;
      height: 30px;
      display: block;

    }

    .message_icon {
      float: left;
      position: relative;
      left: 0px;
      top: -5px;
      background-image: url("../../assets/img/login_message.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 30px;
      height: 30px;
      display: inline-block;
      margin: 10px 0px;

    }

    .authenticator_icon {
      float: left;
      position: relative;
      left: 0px;
      background-image: url("../../assets/img/Lock-Shield3.0.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 25px;
      height: 25px;
      display: inline-block;
      margin: 10px 0px;

    }

    .authenticator_1_icon {
      float: left;
      position: relative;
      left: 0px;
      background-image: url("../../assets/img/Paginate-Filter-1.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 25px;
      height: 25px;
      display: inline-block;
      margin: 10px 0px;

    }

    .authenticator_2_icon {
      float: left;
      position: relative;
      left: 0px;
      background-image: url("../../assets/img/Paginate-Filter-2.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 25px;
      height: 25px;
      display: inline-block;
      margin: 10px 0px;

    }

    .authenticator_3_icon {
      float: left;
      position: relative;
      left: 0px;
      background-image: url("../../assets/img/Paginate-Filter-3.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 25px;
      height: 25px;
      display: inline-block;
      margin: 10px 0px;

    }

    .computer_icon {
      float: left;
      position: relative;
      left: 0px;
      ;
      top: 0px;
      background-image: url("../../assets/img/login_computer.png");
      background-repeat: no-repeat;
      background-size: 150% 150%;
      background-position: left -6px top -7px;
      width: 30px;
      height: 30px;
      display: inline-block;
      margin: 10px 0px;
    }
  }





  // #test1{
  // }
  // #login_login {
  //   background: url(../../assets/img/login.png) no-repeat;
  //   width: 100%;
  //   height: 100vh;
  //   background-size: 100% 100%;
  // }
    .rightContent {
      width: 600px;
      float: right;
      height: 100vh;
      background: #fff;
      padding-left: 30px;
      padding-right: 30px;
    }

  .rightContent-body {
    display: flex;
    flex-direction: column;
    padding: 10px 25px 0px;
    height: 100%;
    background-color: #fff;
    position: relative;
    border-radius: 3px;
    text-align: left;
    overflow-y: auto;
  }

  .localAccount {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .login-footer {
    flex-shrink: 0;
  }

  .rightContent-body .localAccount h1 {
    font-size: 30px;
    margin: 10px 0;
    font-weight: 700;
  }

  .rightContent-body .localAccount h2 {
    font-size: 20px;
    margin: 10px 0;
    font-weight: 700;
  }

  .con {
    text-align: center;
    width: 100%;
    display: table;
    height: 100vh;
    padding: 0;
  }

  .row {
    width: 100%;
    margin: 0;
    display: table-cell;
    vertical-align: middle;
  }

  .panel-default {
    padding: 40px 30px;
    margin-top: auto;
    margin-bottom: auto;
    height: 100%;
    background-color: #fff;
    position: relative;
    border-radius: 3px;

    .Langcheckout {
      position: absolute;
      top: -1px;
      right: -1px;
      width: 30px;
      height: 30px;
      cursor: pointer;
    }

    .panel-body {
      max-width: 380px;
      width: auto;
      margin: 0 auto;
      padding: 0;

      .panel-body-title {
        display: flex;
        align-items: center;
        justify-items: center;
        width: 190px;
        margin: 0 auto;

        .panel-body-titleR {
          font-family: Mv Boli;
          font-size: 22px;
          font-weight: 800;
        }

        .panel-body-titleL {
          margin: 0;
          height: 100px;
          width: 100px;
          display: block;
        }
      }

      .localAccount {

        .has-error .ant-form-explain,
        .has-error .ant-form-split {
          text-align: left;
        }

        h2 {
          font-size: 20px;
          margin: 10px 0;
          font-weight: bold;
        }

        h1 {
          font-size: 30px;
          margin: 10px 0;
          font-weight: bold;
        }
      }
    }
  }

  .login-error-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
  }

  .login-action-error-message {
    font-size: 16px;
    line-height: 16px;
    padding-top: 3px;
    font-weight: bold;
    word-break: break-word;
  }

  .login-logo {
    display: block;
    width: 350px;
    height: 105px;
    margin-left: -15px;
  }

  .login-info {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    margin-right: 6px;
    margin-top: 1px;
  }

  .localAccount .login-subtitle {
    font-size: 20px;
    color: #999;
    margin: 0 0 15px 0;
    padding: 0;
    text-align: left;
  }

  .localAccount .login-title {
    text-align: left;
    font-size: 32px;
    font-weight: bold;
    margin-top: 10px;
    padding: 0;
  }

  .login-form-label {
    display: block;
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 5px;
  }

  .localAccount .ant-form-item {
    margin-bottom: 14px;
  }

  .login-input {
    font-size: 20px;
    height: 50px;
  }

  .forgot-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 10px;
  }

  .forgot-link {
    font-weight: bold;
    color: #4477C0;
    cursor: pointer;
    font-size: 16px;
  }

  .forgot-link:hover {
    color: #40a9ff;
  }

  .login-btn-primary {
    width: 100%;
    height: 50px;
    border-color: #0b97c4;
    border-radius: 8px;
    background-color: #296ec6 !important;
  }

  .login-btn-primary[disabled],
  .login-btn-primary[disabled]:hover,
  .login-btn-primary[disabled]:focus,
  .login-btn-primary[disabled]:active {
    background-color: #C7C7C7 !important;
    cursor: not-allowed !important;
  }

  .login-btn-primary > span {
    font-size: 22px !important;
    font-weight: bold;
    color: white;
  }

  .login-btn-primary[disabled] > span {
    font-size: 22px !important;
    font-weight: bold;
    color: #FFFDF9;
  }

  .divider-or {
    display: flex;
    align-items: center;
    margin: 30px 0;
  }

  .divider-line {
    flex: 1;
    height: 1px;
    background-color: #C7C7C7;
  }

  .divider-text {
    padding: 0 16px;
    color: #999;
    font-size: 16px;
  }

  .divider-line-full {
    height: 1px;
    background-color: #C7C7C7;
    margin: 40px 0;
  }

  .login-btn-sso{
    width: 100%;
    height: 50px;
    background-color: #fff;
    border: 1px solid #C7C7C7;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
  }

  .login-btn-sso[disabled] .microsoft-icon {
    opacity: 0.5;
  }

  .login-btn-sso > span {
    font-size: 22px !important;
    color: #333;
  }

  .login-btn-sso[disabled] > span {
    font-size: 22px !important;
    color: #C7C7C7;
  }

  .microsoft-icon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .login-btn-register{
    width: 100%;
    height: 50px;
    background-color: #EEF5FF;
    border: 1px solid #DBE9FC;
    border-radius: 8px;
  }

  .login-btn-register > span {
    font-size: 22px !important;
    color: #5484CC;
  }

  .help-text {
    margin-top: 30px;
    margin-bottom: 20px;
    font-size: 16px;
    color: grey;
    font-weight: bold;
    text-align: center;
  }

  .forgotDisabled {
    color: #C7C7C7;
    cursor: not-allowed;
    pointer-events: none;
  }
</style>
